"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_admin_1 = require("react-admin");
var Thumbnail_1 = __importDefault(require("./Thumbnail"));
var MeatballMenu_1 = __importDefault(require("../common/MeatballMenu"));
var types_1 = require("@/Types/types");
var doubleClick_1 = require("@/Hooks/doubleClick");
var MediaLibrary_module_css_1 = __importDefault(require("./MediaLibrary.module.css"));
var q_play_core_1 = require("@nordicscreen/q-play-core");
var q_play_components_1 = require("@nordicscreen/q-play-components");
var react_i18next_1 = require("react-i18next");
var MediaPreviewModal_1 = __importDefault(require("./MediaPreviewModal"));
var CustomEmpty_1 = __importDefault(require("./CustomEmpty"));
var MediaDetailsDialog_1 = __importDefault(require("./MediaDetailsDialog"));
var react_dnd_1 = require("react-dnd");
var react_dnd_html5_backend_1 = require("react-dnd-html5-backend");
var MediaLibraryGridView = function (_a) {
    var folders = _a.folders, media = _a.media, onDeleteFolder = _a.onDeleteFolder, onDownloadMedia = _a.onDownloadMedia, onDeleteMedia = _a.onDeleteMedia, selectedFolderIds = _a.selectedFolderIds, setSelectedFolderIds = _a.setSelectedFolderIds, selectedMediaIds = _a.selectedMediaIds, setSelectedMediaIds = _a.setSelectedMediaIds, fetchFolderContents = _a.fetchFolderContents, collectionName = _a.collectionName, mediaDoubleClickHandler = _a.mediaDoubleClickHandler, _b = _a.searchQuery, searchQuery = _b === void 0 ? "" : _b, handleMoveMultipleMediaToFolder = _a.handleMoveMultipleMediaToFolder, handleMoveMultipleFoldersToFolder = _a.handleMoveMultipleFoldersToFolder, openFolderAccessModal = _a.openFolderAccessModal, folderPermissions = _a.folderPermissions, handleChangeFolderName = _a.handleChangeFolderName, permissions = _a.permissions;
    var _c = (0, react_1.useState)(null), showMenu = _c[0], setShowMenu = _c[1];
    var _d = (0, react_1.useState)(false), previewModalShown = _d[0], setPreviewModalShown = _d[1];
    var _e = (0, react_1.useState)(null), previewImageUrl = _e[0], setPreviewImageUrl = _e[1];
    var _f = (0, react_1.useState)(null), previewMediaType = _f[0], setPreviewMediaType = _f[1];
    var _g = (0, react_1.useState)(false), confirmationModalOpened = _g[0], setConfirmationModalOpened = _g[1];
    var _h = (0, react_1.useState)({ folders: [], media: [] }), itemsToDelete = _h[0], setItemsToDelete = _h[1];
    var logger = q_play_core_1.logManager.getLogger();
    var t = (0, react_i18next_1.useTranslation)().t;
    var anySelected = selectedFolderIds.length > 0 || selectedMediaIds.length > 0;
    var _j = (0, react_1.useState)(false), detailsDialogOpen = _j[0], setDetailsDialogOpen = _j[1];
    var _k = (0, react_1.useState)(null), selectedMediaDetails = _k[0], setSelectedMediaDetails = _k[1];
    var _l = (0, react_1.useState)(null), anchorEl = _l[0], setAnchorEl = _l[1];
    var _m = (0, react_1.useState)(0), draggingItemCount = _m[0], setDraggingItemCount = _m[1];
    var _o = (0, react_1.useState)(null), draggedItemId = _o[0], setDraggedItemId = _o[1];
    var toggleConfirmationModal = function () {
        setConfirmationModalOpened(function (prevState) { return !prevState; });
    };
    var filteredFolders = (0, react_1.useMemo)(function () { return folders.filter(function (folder) { return folder.name.toLowerCase().includes(searchQuery.toLowerCase()); }); }, [folders, searchQuery]);
    var filteredMedia = (0, react_1.useMemo)(function () { return media.filter(function (mediaItem) { return mediaItem.name.toLowerCase().includes(searchQuery.toLowerCase()); }); }, [media, searchQuery]);
    var handleMouseEnter = (0, react_1.useCallback)(function (type, id) {
        setShowMenu("".concat(type, "-").concat(id));
    }, []);
    var handleMouseLeave = (0, react_1.useCallback)(function () {
        setShowMenu(null);
    }, []);
    var toggleFolderSelection = function (folderId) {
        setSelectedFolderIds(function (prevSelected) {
            return prevSelected.includes(folderId)
                ? prevSelected.filter(function (id) { return id !== folderId; })
                : __spreadArray(__spreadArray([], prevSelected, true), [folderId], false);
        });
    };
    var toggleMediaSelection = function (mediaId) {
        setSelectedMediaIds(function (prevSelected) {
            return prevSelected.includes(mediaId)
                ? prevSelected.filter(function (id) { return id !== mediaId; })
                : __spreadArray(__spreadArray([], prevSelected, true), [mediaId], false);
        });
    };
    var togglePreviewModal = (0, react_1.useCallback)(function () {
        setPreviewModalShown(function (prev) { return !prev; });
    }, []);
    var viewMedia = (0, react_1.useCallback)(function (media) {
        setPreviewImageUrl(media.url);
        setPreviewMediaType(media.mime_type);
        togglePreviewModal();
    }, [togglePreviewModal]);
    var handleDeleteRequest = function (folders, media) {
        setItemsToDelete({ folders: folders, media: media });
        toggleConfirmationModal();
    };
    var handleConfirmDelete = function () {
        try {
            itemsToDelete.folders.forEach(function (id) {
                onDeleteFolder(id);
            });
            itemsToDelete.media.forEach(function (id) {
                onDeleteMedia(collectionName, id);
            });
            setItemsToDelete({ folders: [], media: [] });
            toggleConfirmationModal();
        }
        catch (error) {
            logger.error("Error during deletion:", error);
        }
    };
    var handleViewMedia = (0, react_1.useCallback)(function (e, media) {
        e.stopPropagation();
        viewMedia(media);
    }, [viewMedia]);
    var openDetailsDialog = (0, react_1.useCallback)(function (media, event) {
        setSelectedMediaDetails(media);
        setAnchorEl(event.currentTarget);
        setDetailsDialogOpen(true);
    }, []);
    var closeDetailsDialog = (0, react_1.useCallback)(function () {
        setDetailsDialogOpen(false);
        setSelectedMediaDetails(null);
        setAnchorEl(null);
    }, []);
    var _p = (0, react_dnd_1.useDrop)({
        accept: [react_dnd_html5_backend_1.NativeTypes.FILE, "MEDIA", "FOLDER"],
        drop: function (item, monitor) {
            var dropResult = monitor.getDropResult();
            var targetFolderId = dropResult === null || dropResult === void 0 ? void 0 : dropResult.folderId;
            if (!targetFolderId)
                return;
            var itemType = monitor.getItemType();
            var selectedMedia = selectedMediaIds.length > 0
                ? selectedMediaIds.map(function (id) { return media.find(function (m) { return (m === null || m === void 0 ? void 0 : m.id) === id; }); }).filter(function (m) { return m !== undefined; })
                : [];
            var selectedFolders = selectedFolderIds.length > 0
                ? selectedFolderIds.map(function (id) { return folders.find(function (f) { return (f === null || f === void 0 ? void 0 : f.id) === id; }); }).filter(function (f) { return f !== undefined; })
                : [];
            if (selectedFolderIds.includes(targetFolderId)) {
                logger.error("Cannot move media into a selected folder");
                return;
            }
            if (itemType === "MEDIA" && !selectedMediaIds.includes(item.id)) {
                selectedMedia.push(item);
            }
            else if (itemType === "FOLDER" && !selectedFolderIds.includes(item.id)) {
                var folder = item;
                if (folder.id === targetFolderId) {
                    return;
                }
                selectedFolders.push(folder);
            }
            if (selectedMedia.length > 0) {
                handleMoveMultipleMediaToFolder(selectedMedia, targetFolderId);
            }
            if (selectedFolders.length > 0) {
                handleMoveMultipleFoldersToFolder(selectedFolders, targetFolderId);
            }
        },
        collect: function (monitor) { return ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }); },
    }), drop = _p[1];
    var handleDragStart = function (id) {
        var selectedCount = selectedMediaIds.length + selectedFolderIds.length;
        setDraggingItemCount(selectedCount);
        setDraggedItemId(id);
    };
    var handleDragEnd = function () {
        setDraggingItemCount(0);
        setDraggedItemId(null);
    };
    var findFolderNameById = function (id) {
        var folder = folders.find(function (folder) { return folder.id === id; });
        return folder ? folder.name : "";
    };
    var handleOpenFolderAccessModal = function (folderId) {
        var folderName = findFolderNameById(folderId);
        openFolderAccessModal(folderId, folderName);
        setShowMenu(null);
    };
    return (react_1.default.createElement(react_dnd_1.DndProvider, { backend: react_dnd_html5_backend_1.HTML5Backend },
        react_1.default.createElement("div", { ref: drop, style: { width: "100%", height: "100%" } },
            react_1.default.createElement(react_admin_1.InfiniteList, { exporter: false, pagination: false, sx: {
                    "& .RaList-content": {
                        boxShadow: "none",
                        backgroundColor: "white",
                        overflow: "hidden",
                    },
                    "& .RaList-actions": {
                        backgroundColor: "white",
                    },
                }, "data-cy": "mediaLibraryGridView", empty: react_1.default.createElement(CustomEmpty_1.default, null), queryOptions: {
                    refetchOnWindowFocus: false,
                    refetchOnReconnect: false,
                    refetchOnMount: false,
                    refetchInterval: 1000 * 60,
                } },
                react_1.default.createElement("div", { className: MediaLibrary_module_css_1.default["thumbnail-grid-container"] },
                    filteredFolders.map(function (folder) {
                        var handleClick = (0, doubleClick_1.useDoubleClick)({
                            onSingleClick: function () {
                                toggleFolderSelection(folder.id);
                            },
                            onDoubleClick: function () {
                                fetchFolderContents(folder.id, folder.name);
                            },
                        });
                        var isSelected = selectedFolderIds.includes(folder.id);
                        var folderOpacity = anySelected && !isSelected ? 0.5 : 1;
                        var _a = (0, react_dnd_1.useDrop)({
                            accept: ["MEDIA", "FOLDER"],
                            drop: function () { return ({ folderId: folder.id }); },
                            collect: function (monitor) { return ({
                                isOver: monitor.isOver(),
                                canDrop: monitor.canDrop(),
                            }); },
                        }), folderIsOver = _a[0].isOver, folderDrop = _a[1];
                        var _b = (0, react_dnd_1.useDrag)({
                            type: "FOLDER",
                            item: function () {
                                handleDragStart(folder.id);
                                return { id: folder.id, selectedMediaIds: selectedMediaIds, selectedFolderIds: selectedFolderIds, selectedCount: draggingItemCount, draggedItemId: draggedItemId };
                            },
                            end: function () { return handleDragEnd(); },
                            collect: function (monitor) { return ({
                                isDragging: monitor.isDragging(),
                            }); },
                        }), folderIsDragging = _b[0].isDragging, folderDrag = _b[1];
                        var thumbnailRef = (0, react_1.useRef)(null);
                        return (react_1.default.createElement("div", { key: folder.id, ref: function (node) {
                                folderDrop(node);
                                folderDrag(thumbnailRef);
                            }, style: {
                                position: "relative",
                                maxHeight: "145px",
                                outline: isSelected ? "2px solid var(--primary-color)" : "none",
                                outlineOffset: "-4px",
                                borderRadius: "10px",
                                backgroundColor: isSelected ? "#f5ffce61" : "transparent",
                                padding: "10px",
                                opacity: folderOpacity,
                                background: folderIsOver ? "#F6FCE9" : "transparent",
                            }, className: MediaLibrary_module_css_1.default.grid_view_folder_mapping, onMouseEnter: function () { return handleMouseEnter("folder", folder.id); }, onMouseLeave: handleMouseLeave, onClick: handleClick, "data-cy": "gridViewFolder" },
                            react_1.default.createElement(Thumbnail_1.default, { item: folder, isFolder: true, ref: thumbnailRef, draggingItemCount: draggingItemCount, draggedItemId: draggedItemId, isDragging: folderIsDragging, permissions: permissions, selectedFolderIds: selectedFolderIds, handleChangeFolderName: handleChangeFolderName, folderPermissions: folderPermissions }),
                            react_1.default.createElement(MeatballMenu_1.default, { onDelete: function () { return handleDeleteRequest([folder.id], []); }, onManageResourceAccess: function () { return handleOpenFolderAccessModal(folder.id); }, menuSx: { marginLeft: "25px" }, resourceType: types_1.ResourceType.FOLDER, resourceId: folder.id, resourceName: folder.name, folderPermissions: folderPermissions, style: {
                                    position: "absolute",
                                    top: "9px",
                                    right: "15px",
                                    zIndex: 100,
                                    opacity: 1,
                                    display: (showMenu === "folder-".concat(folder.id) && !folderIsDragging) ? "inline-block" : "none",
                                } })));
                    }),
                    filteredMedia.map(function (media) {
                        var handleClick = (0, doubleClick_1.useDoubleClick)({
                            onSingleClick: function () {
                                toggleMediaSelection(media.id);
                            },
                            onDoubleClick: function () {
                                viewMedia(media);
                                mediaDoubleClickHandler(media.id);
                            },
                        });
                        var isSelected = selectedMediaIds.includes(media.id);
                        var mediaOpacity = anySelected && !isSelected ? 0.5 : 1;
                        var _a = (0, react_dnd_1.useDrag)({
                            type: "MEDIA",
                            item: function () {
                                handleDragStart(media.id);
                                return { id: media.id, selectedMediaIds: selectedMediaIds, selectedFolderIds: selectedFolderIds, selectedCount: draggingItemCount, draggedItemId: draggedItemId };
                            },
                            end: function () { return handleDragEnd(); },
                            collect: function (monitor) { return ({
                                mediaIsDragging: monitor.isDragging(),
                            }); },
                        }), mediaIsDragging = _a[0].mediaIsDragging, drag = _a[1];
                        var thumbnailRef = (0, react_1.useRef)(null);
                        return (react_1.default.createElement("div", { key: media.uuid, ref: function () {
                                drag(thumbnailRef);
                            }, style: {
                                position: "relative",
                                maxHeight: "150px",
                                outline: isSelected ? "2px solid var(--primary-color)" : "none",
                                outlineOffset: "-4px",
                                borderRadius: "10px",
                                backgroundColor: isSelected ? "#f5ffce61" : "transparent",
                                padding: "10px",
                                opacity: mediaOpacity,
                            }, onMouseEnter: function () { return handleMouseEnter("media", media.id); }, onMouseLeave: handleMouseLeave, onClick: handleClick, "data-cy": "gridViewMediaItem" },
                            react_1.default.createElement(Thumbnail_1.default, { item: media, isFolder: false, ref: thumbnailRef, draggingItemCount: draggingItemCount, draggedItemId: draggedItemId, isDragging: mediaIsDragging, permissions: permissions, selectedFolderIds: selectedFolderIds, handleChangeFolderName: handleChangeFolderName, folderPermissions: folderPermissions }),
                            react_1.default.createElement(MeatballMenu_1.default, { onView: function (e) { return handleViewMedia(e, media); }, onDownload: function () {
                                    onDownloadMedia([media.id]);
                                }, onDetails: function (e) { return openDetailsDialog(media, e); }, onDelete: function () { return handleDeleteRequest([], [media.id]); }, menuSx: { marginLeft: "25px" }, resourceType: types_1.ResourceType.MEDIA, resourceId: media.id, folderPermissions: folderPermissions, style: {
                                    position: "absolute",
                                    top: 0,
                                    left: "116px",
                                    zIndex: 100,
                                    opacity: 1,
                                    display: (showMenu === "media-".concat(media.id) && !mediaIsDragging) ? "inline-block" : "none",
                                } })));
                    })))),
        react_1.default.createElement(MediaPreviewModal_1.default, { isShown: previewModalShown, toggle: togglePreviewModal, url: previewImageUrl !== null && previewImageUrl !== void 0 ? previewImageUrl : "", mediaType: previewMediaType !== null && previewMediaType !== void 0 ? previewMediaType : "" }),
        react_1.default.createElement(MediaDetailsDialog_1.default, { open: detailsDialogOpen, onClose: closeDetailsDialog, media: selectedMediaDetails, anchorEl: anchorEl, viewType: "grid" }),
        react_1.default.createElement(q_play_components_1.ConfirmationModal, { isShown: confirmationModalOpened, onClose: toggleConfirmationModal, onConfirm: handleConfirmDelete, onCancel: toggleConfirmationModal, headerText: t("Confirm"), message: t("Are you sure you want to delete the selected items?"), actionRequired: true, confirmLabel: t("Yes"), cancelLabel: t("Cancel"), centered: true })));
};
exports.default = MediaLibraryGridView;
